import React, {useEffect, useState} from 'react';
import useAxiosIntercept from "../../hooks/useAxiosIntercept";

function BillSummary({summary, downloadInvoice}) {
    var addOns = "";
    return(<>
            {summary.length == 0 ?
                <tr>
                    <td>Order details not found</td>
                </tr>
                :
                <tr className="expanded">
                <td colSpan="7">
                    <div className="vehicleBill">
                        <div className="summary">
                            <div className="YRow pt-8 pb-8">
                                <div className="boxT1">
                                    <h4>
                                        Bill summary
                                        <span className="sds" onClick={()=>downloadInvoice()}>
                                            <a href="javascript:coid(0);">
                                              <i className="material-symbols-rounded mt-m">download</i>
                                              Download invoice
                                            </a>
                                        </span>
                                    </h4>
                                    <div className="listRow">
                                        <h5>Packages sold</h5>
                                        <p>
                                            {" "}
                                            {summary?.package_info?.package_name !=null ?
                                                <span>
                                                    <b className="success"></b>{summary.package_info.package_name}
                                                </span>
                                                :
                                                <span>
                                                    <b className="success"></b>NA
                                                </span>
                                            }
                                            {" "}
                                            { summary?.package_info?.amount!=null ?
                                                <span>${summary.package_info?.amount}</span> 
                                                :
                                                <span>NA</span>
                                            }{" "}
                                        </p>
                                        {/*<p>*/}
                                        {/*    {" "}*/}
                                        {/*    <span>*/}
                                        {/*        <b className="success">20 x</b>MB-EQB-Gold 4 (60-80 kWh)*/}
                                        {/*    </span>{" "}*/}
                                        {/*    <span>$10,000</span>{" "}*/}
                                        {/*</p>*/}
                                    </div>
                                    <div className="listRow">
                                        <h5>Charge</h5>
                                        <p>
                                            {" "}
                                            {summary?.charging_data?.charging_done != null && summary?.charging_data?.service_charge != null
                                                ?
                                                <span>
                                                    <b className="success"></b>{summary.charging_data.charging_done}kWh x ${summary.charging_data.service_charge}
                                                </span>
                                                :
                                                <span>
                                                    <b className="success"></b>NA
                                                </span>
                                            }
                                            {" "}
                                            {summary?.charging_data?.charging_cost!= null
                                                ?
                                                <span>${summary.charging_data.charging_cost}</span>
                                                :
                                                <span>NA</span>
                                            }
                                        </p>
                                    </div>

                                  {/* {console.log(summary,"summary")}   
                          {summary?.booking_add_ons ? (
                            summary?.booking_add_ons.map(
                              (bookingAddOnsData, index) => {
                                bookingAddOnsData?.service_name &&
                                bookingAddOnsData.service_status !== "6" ? (
                                  <>
                                    {
                                      (addOns =
                                        addOns +
                                        bookingAddOnsData?.service_name +
                                        ",")
                                      // bookingAddOnsData?.service_name
                                    }
                                  </>
                                ) : (
                                  <>NA</>
                                );
                              }
                            )
                          ) : (
                            <></>
                          )}

                          <td>
                            {addOns
                              ? addOns.substring(0, addOns.length - 1)
                              : "NA"}
                          </td> */}
                                    

                                    <div className="listRow">
                                          <h5>Add-ons</h5>

                                          {summary?.booking_add_ons ? (
                                            summary?.booking_add_ons.map(
                                              (bookingAddOnsData) => {
                                                const {
                                                  service_charge,
                                                  service_name,
                                                  service_status,
                                                } = bookingAddOnsData;
                                                return service_status !==
                                                  "6" ? (
                                                  <>
                                                    <p>
                                                      <span>
                                                        {service_name !== null
                                                          ? service_name
                                                          : "NA"}
                                                      </span>
                                                      <span>
                                                        {service_charge !==
                                                        null ? (
                                                          service_charge.slice(
                                                            0,
                                                            1
                                                          ) != "0" ? (
                                                            "$" + service_charge
                                                          ) : (
                                                            "Free"
                                                          )
                                                        ) : (
                                                          <>NA</>
                                                        )}
                                                      </span>
                                                    </p>
                                                  </>
                                                ) : (
                                                  <></>
                                                );
                                              }
                                            )
                                          ) : (
                                            <>NA</>
                                          )}
                                    </div>
                                     <div className="listRow">
                                        {summary?.booking_info?.subtotal!= null ?
                                            <h5>
                                                Total before GST <span>${summary.booking_info.subtotal}</span>
                                            </h5>
                                            :
                                            <h5>
                                                Total before GST <span>NA</span>
                                            </h5>
                                        }
                                        
                                    </div> 
                                    
                                     <div className="listRow">
                                          <h5>Surcharge</h5>
                                          <p>
                                            <span>Service charge</span>

                                            <span>
                                              {summary?.booking_info?.service_cost.slice(
                                                0,
                                                1
                                              ) != "0"
                                                ? "$" +
                                                  summary?.booking_info
                                                    ?.service_cost
                                                : "Free"}
                                            </span>
                                          </p>
                                          <p>
                                            <span>Parking charge</span>
                                            <span>
                                              {summary?.booking_info?.parking_fee.slice(
                                                0,
                                                1
                                              ) != "0"
                                                ? "$" +
                                                  summary?.booking_info
                                                    ?.parking_fee
                                                : "Free"}
                                            </span>
                                          </p>
                                        </div>
                                    {/*<div className="listRow">*/}
                                    {/*    <h5>Promos sold</h5>*/}
                                    {/*    <p>*/}
                                    {/*        {" "}*/}
                                    {/*        <span>MB-Christmas Charge&amp;Wash</span> <span>$0</span>{" "}*/}
                                    {/*    </p>*/}
                                    {/*    <p>*/}
                                    {/*        {" "}*/}
                                    {/*        <span>Strides 28</span> <span>$0</span>{" "}*/}
                                    {/*    </p>*/}
                                    {/*</div>*/}
                                    <div className="listRow">
                                       
                                        {summary?.booking_info?.gst_cost != null
                                            ?
                                            <p>
                                                {" "}
                                                <span>GST</span> <span>${summary.booking_info.gst_cost}</span>{" "}
                                            </p>
                                            :
                                            <p>
                                                {" "}
                                                <span>GST</span> <span>NA</span>{" "}
                                            </p>
                                        }
                                    </div> 
                                    <div className="listRow gTotal pad-0 mar-0">
                                        {summary?.booking_info?.total != null ?
                                            <p>
                                                {" "}
                                                <span>Total bill</span> <span>${summary.booking_info.total}</span>{" "}
                                            </p>
                                            :
                                            <p>
                                                {" "}
                                                <span>Total bill</span> <span>NA</span>{" "}
                                            </p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </td>

            </tr>}
        </>

    )
}

export default BillSummary;